"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPriceDetail = void 0;
const spu_1 = require("@tencent/tccp-frontend-contract/spu");
const MeasureUnitText_1 = require("../constant/MeasureUnitText");
const order_1 = require("./order");
function buildMapping(spuMeta, paramList = [], refinedOrder = []) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const RefSpuMapping = {};
    const GenericSpecMapping = {};
    const refinedOrderIndexMapping = {};
    const originalOrderIndexMapping = {};
    // 构建参数排序索引表
    refinedOrder.forEach((key, index) => {
        refinedOrderIndexMapping[key] = index;
    });
    paramList.forEach(({ paramKey }, index) => {
        originalOrderIndexMapping[paramKey] = index;
    });
    const SortedParamList = Array.from(paramList).sort(({ paramKey: a }, { paramKey: b }) => {
        const refinedOrderIndexA = refinedOrderIndexMapping[a];
        const refinedOrderIndexB = refinedOrderIndexMapping[b];
        if (refinedOrderIndexA !== undefined && refinedOrderIndexB !== undefined) {
            return refinedOrderIndexA - refinedOrderIndexB;
        }
        return originalOrderIndexMapping[a] - originalOrderIndexMapping[b];
    });
    if (spuMeta) {
        RefSpuMapping[`spuitem://${spuMeta.SpuCode}`] = {
            Name: spuMeta.SpuShortName,
            SpuShortName: spuMeta.SpuShortName,
            MeasureUnit: (_a = spuMeta.MeasureUnit) !== null && _a !== void 0 ? _a : '',
            QuantityUnit: (_b = spuMeta.QuantityUnit) !== null && _b !== void 0 ? _b : '',
        };
    }
    for (const param of SortedParamList) {
        const { SpuCode: OwnerSpuCode } = param.spu;
        const { SpecCode, SpecName, ValueRestrictionList, SpecValueUnit } = param.spec;
        if (param.isRef) {
            const spuItemPath = `spuitem://${[
                ...param.paramPath.map(p => 
                // 现在ValueRestrictionList只有一项
                `${p.spu.SpuCode}.${p.spec.SpecCode}[0]`),
                // 现有用量和数量作为固定参数的情况下，下一个一定是当前引用SPU的用量或数量
                (_c = param.next) === null || _c === void 0 ? void 0 : _c.spu.SpuCode,
            ].join('>')}`;
            RefSpuMapping[spuItemPath] = {
                Name: SpecName,
                // 现有用量和数量作为固定参数的情况下，下一个一定是当前引用SPU的用量或数量
                SpuShortName: (_e = (_d = param.next) === null || _d === void 0 ? void 0 : _d.spu.SpuShortName) !== null && _e !== void 0 ? _e : '',
                MeasureUnit: (_h = MeasureUnitText_1.MeasureUnitTextMap[(_g = (_f = param.next) === null || _f === void 0 ? void 0 : _f.spu) === null || _g === void 0 ? void 0 : _g.MeasureUnit]) !== null && _h !== void 0 ? _h : '',
                QuantityUnit: (_l = (_k = (_j = param.next) === null || _j === void 0 ? void 0 : _j.spu) === null || _k === void 0 ? void 0 : _k.QuantityUnit) !== null && _l !== void 0 ? _l : '',
            };
        }
        else {
            if (!GenericSpecMapping[OwnerSpuCode]) {
                GenericSpecMapping[OwnerSpuCode] = {};
            }
            GenericSpecMapping[OwnerSpuCode][SpecCode] = {
                Name: SpecName,
                Unit: SpecValueUnit !== null && SpecValueUnit !== void 0 ? SpecValueUnit : '',
            };
            const restriction = ValueRestrictionList.at(0);
            if ((restriction === null || restriction === void 0 ? void 0 : restriction.RestrictionType) === spu_1.RestrictionEnum.Choice) {
                GenericSpecMapping[OwnerSpuCode][SpecCode].TextMapping = {};
                for (const rule of restriction.RestrictionRuleList) {
                    GenericSpecMapping[OwnerSpuCode][SpecCode].TextMapping[rule.Value] = rule.ValueName;
                }
            }
        }
    }
    return {
        RefSpuMapping,
        GenericSpecMapping,
        SortedParamList,
    };
}
function buildPriceDetail({ spuMeta, paramList = [], orderItem, orderItemPrice, refinedOrder, }) {
    var _a, _b;
    // 构建引用Spu的信息Mapping
    const { RefSpuMapping, GenericSpecMapping, SortedParamList } = buildMapping(spuMeta, paramList, refinedOrder);
    const values = orderItem ? (0, order_1.fromOrderItemToValues)(orderItem, paramList) : {};
    const list = (_b = (_a = orderItemPrice === null || orderItemPrice === void 0 ? void 0 : orderItemPrice.SpuItemPriceList) === null || _a === void 0 ? void 0 : _a.map(result => {
        var _a, _b, _c, _d, _e, _f, _g;
        const { MeasureUnit = '' } = (_a = RefSpuMapping[result.SpuItemPath]) !== null && _a !== void 0 ? _a : {};
        const HasPrice = Number(result.Amount) !== 0;
        const HasDiscount = ((_b = result.DiscountDetail) === null || _b === void 0 ? void 0 : _b.DiscountRatio) !== undefined &&
            ((_c = result.DiscountDetail) === null || _c === void 0 ? void 0 : _c.DiscountRatio) !== null &&
            result.DiscountDetail.DiscountRatio !== 100;
        const pricingCodeList = (_e = (_d = result.PricingItemDetailList) === null || _d === void 0 ? void 0 : _d.map(({ PricingCode }) => PricingCode)) !== null && _e !== void 0 ? _e : [];
        const specPriceCodeList = (_g = (_f = result.SpecPriceDetailList) === null || _f === void 0 ? void 0 : _f.map(({ Code }) => Code)) !== null && _g !== void 0 ? _g : [];
        const SpecList = SortedParamList.filter(param => param.spu.SpuCode === result.SpuCode &&
            specPriceCodeList.includes(param.spec.SpecCode) &&
            !param.isRef)
            .map(param => ({
            SpecCode: param.spec.SpecCode,
            SpecValue: values[param.paramKey],
        }))
            .filter(({ SpecValue }) => SpecValue !== undefined && SpecValue !== null)
            .map(({ SpecCode, SpecValue }) => {
            var _a, _b;
            const { Name = '', TextMapping, Unit = '', } = (_a = GenericSpecMapping[result.SpuCode][SpecCode]) !== null && _a !== void 0 ? _a : {};
            let Text;
            let Value;
            if (Array.isArray(SpecValue)) {
                Value = SpecValue.map(v => String(v));
                Text = SpecValue.map(v => { var _a; return (_a = TextMapping === null || TextMapping === void 0 ? void 0 : TextMapping[v]) !== null && _a !== void 0 ? _a : String(v); });
            }
            else {
                Value = String(SpecValue);
                Text = (_b = TextMapping === null || TextMapping === void 0 ? void 0 : TextMapping[SpecValue]) !== null && _b !== void 0 ? _b : Value;
            }
            return {
                SpecCode,
                Name,
                Value,
                Text,
                Unit,
            };
        });
        const PricingItemList = SortedParamList.filter(param => param.spu.SpuCode === result.SpuCode &&
            pricingCodeList.includes(param.spec.SpecCode) &&
            !param.isRef)
            .map(param => ({
            PricingCode: param.spec.SpecCode,
            SpecValue: values[param.paramKey],
        }))
            .filter(({ SpecValue }) => SpecValue !== undefined && SpecValue !== null)
            .map(({ PricingCode, SpecValue }) => {
            var _a, _b;
            const { Name = '', TextMapping, Unit = '', } = (_a = GenericSpecMapping[result.SpuCode][PricingCode]) !== null && _a !== void 0 ? _a : {};
            let Text;
            let Value;
            if (Array.isArray(SpecValue)) {
                Value = SpecValue.map(v => String(v));
                Text = SpecValue.map(v => { var _a; return (_a = TextMapping === null || TextMapping === void 0 ? void 0 : TextMapping[v]) !== null && _a !== void 0 ? _a : String(v); });
            }
            else {
                Value = String(SpecValue);
                Text = (_b = TextMapping === null || TextMapping === void 0 ? void 0 : TextMapping[SpecValue]) !== null && _b !== void 0 ? _b : Value;
            }
            return {
                PricingCode,
                Name,
                Value,
                Text,
                Unit,
            };
        });
        return Object.assign(Object.assign({ SpuCode: result.SpuCode, SpuItemPath: result.SpuItemPath }, RefSpuMapping[result.SpuItemPath]), { SpecList,
            PricingItemList, Quantity: result.Quantity, PricingCoefficient: result.PricingCoefficient, MeasureUnit, Price: result.Price, Amount: result.Amount, DiscountRatio: result.DiscountDetail.DiscountRatio, AmountAfterDiscount: result.AmountAfterDiscount, HasPrice,
            HasDiscount });
    })) !== null && _b !== void 0 ? _b : [];
    return list;
}
exports.buildPriceDetail = buildPriceDetail;
